import Dashboard from "layouts/dashboard";
import Login from "views/pages/login/Login";
import Register from "views/pages/register/Register"
import Degree from "views/pages/degree/Degree";
import Department from "views/pages/department/Department";
import Campus from "views/pages/campus/Campus";
import Campaign from "views/pages/campaign/Campaign";
import OrganizationRegister from "views/pages/register/organization_register/OrganizationRegister"
import Forms from "views/pages/forms/Forms";
import Types from "views/pages/type/Types";
import AssignmentIcon from '@mui/icons-material/Assignment';

// @mui icons
import Icon from "@mui/material/Icon";
import Applicants from "views/pages/applicants/Applicants";
import ManageApplications from "views/pages/Applications/ManageApplications";
import EntryTests from "views/pages/entry_tests/EntryTests";
import TestInterviewScores from "views/pages/entry_tests/TestInterviewScores";
import SelectedApplications from "views/pages/Applications/SelectedApplications";
import FeeStructure from "views/pages/fee_management/FeeStructure";
import ReviewApplications from "views/pages/Applications/ReviewApplications";
import TestUpload from "views/pages/Applications/TestUpload";
import UploadSelectionList from "views/pages/Applications/UploadSelectionList";
import POSVouchers from "views/pages/vouchers/POSVouchers";
import ExportApplication from "views/pages/Applications/ExportApplication";
import OrganizationApiSetup from "views/pages/organization_api_setup/OrganizationApiSetup";
import PreRegisterApplications from "views/pages/Applications/PreRegisterApplications";
import Users from "views/pages/users/Users";
import MeritList from "views/pages/Applications/MeritList";
import TestResultEntry from "views/pages/Applications/TestResultEntry";
import Settings from "views/pages/settings/Settings";
import SettingsV2 from "views/pages/settings/SettingsV2";
import EntryTestTemplate from "views/pages/template/EntryTestTemplate";
// import AdmissionLetter from "views/pages/template/AdmissionLetter";
import VoucherTemplate from "views/pages/template/VoucherTemplate";
import HomeIcon from '@mui/icons-material/Home';
import Quota from "views/pages/quota/Quota";
import Faculty from "views/pages/faculty/Faculty";
import { Department2 } from "views/pages/department/Departmentv2";
import Departmentv2 from "views/pages/department/Departmentv2";
import Program from "views/pages/program/Program";
import Batch from "views/pages/batch/Batch";
import MeritListV2 from "views/pages/Applications/MeritListV2";
import WaitingList from "views/pages/Applications/WaitingList";
import AffiliateApplication from "views/pages/Applications/AffiliateApplication";
import UploadAffiliateCollege from "views/pages/Applications/UploadAffiliateCollege";
import BasicInfoCorrection from "views/pages/Applications/BasicInfoCorrection";
import AcademicsInfoCorrection from "views/pages/Applications/AcademicsInfoCorrection";
import ProgramCorrection from "views/pages/Applications/ProgramCorrection";
import TestCorrection from "views/pages/Applications/TestCorrection";
import AddApplication from "views/pages/Applications/AddApplication";
import ApplicantCorrection from "views/pages/ApplicantCorrection/ApplicantCorrection";
import SearchApplications from "views/pages/Applications/SearchApplications";
import Vouchers from "views/pages/fee_management/Vouchers";
import RegistrarVouchers from "views/pages/fee_management/RegistrarVouchers";
import SemesterVouchers from "views/pages/fee_management/SemesterVouchers";
import MeritListTemplates from "views/pages/Applications/MeritListTemplates";
import FeeStructureV2 from "views/pages/fee_management/FeeStructureV2";
import FeeTransfer from "views/pages/Applications/FeeTransfer";
import AdmissionCancel from "views/pages/Applications/AdmissionCancel";
import AdmissionSummaryReport from "views/pages/Reports/AdmissionSummaryReport";
import TransferredApplications from "views/pages/Reports/TransferredApplications"
import AdmissionDraftStructures from "views/pages/Applications/AdmissionDraftStructures";
import ApplicationDrafts from "views/pages/Applications/ApplicationDrafts";
import TestCandidateReport from "views/pages/Reports/TestCandidateReport";
import UserLoginReport from "views/pages/Reports/UserLoginReport";
import ShiftProgram from "views/pages/Applications/ShiftProgram";
import AllowApplication from "views/pages/AllowApplication/AllowApplication";
import { hasResource } from "hooks/checkPermission";
import BulkMeritList from "views/pages/Applications/BulkMeritList";
import AllowedApplicantReport from "views/pages/Reports/AllowedApplicantReport";
import FeeCollectionReport from "views/pages/Reports/FeeCollectionReport";
import SendRequestToHMS from "views/pages/HostelManagement/SendRequestToHMS";
import MakeStudent from "views/pages/HostelManagement/MakeStudent";
import HostelVouchers from "views/pages/fee_management/HostelVouchers";
import ConsolidatedVoucherReport from "views/pages/fee_management/ConsolidatedVoucherReport";
import UploadBankFile from "views/pages/voucher_reconciliation/UploadBankFile";
import ReconciliationDashboard from "views/pages/voucher_reconciliation/ReconciliationDashboard";
import SportTrialApplications from "views/pages/Applications/SportTrialApplications";
const routes = [
  {
    type: "collapse",
    name: "Admin Dashboard",
    key: "admin-dashboard",
    icon: <HomeIcon  style={{color:"gray", marginBottom:"14px"}} fontSize="small">dashboard</HomeIcon> ,
    route: "/admin-dashboard",
    component: <Dashboard />,
  },
  {
    type: "nested",
    name: "Organization Setup",
    key: "organization-setup",
    icon: <Icon fontSize="small">account_balance</Icon>,
    children: [
      // {
      //   type: "collapse",
      //   name: "Degree",
      //   key: "degree",
      //   icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
      //   route: "/degree",
      //   component: <Degree />,
      // },
      // {
      //   type: "collapse",
      //   name: "Department",
      //   key: "department",
      //   icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
      //   route: "/department",
      //   component: <Department />,
      // },
      {
        type: "collapse",
        name: "Campus",
        key: "campus",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/campus",
        component: <Campus />,
        resource:'Campus',
      },
      // {
      //   type: "collapse",
      //   name:"API Settings",
      //   key: "organization_api_setup",
      //   icon: <Icon fontSize="small" style={{color: "gray"}}>settings</Icon>,
      //   route: "/organization_api_settings",
      //   component: <OrganizationApiSetup />,
      // },
      
      {
        type: "collapse",
        name:"Faculty",
        key: "faculty",
        icon: <Icon fontSize="small" style={{color: "gray"}}>radio_button_unchecked</Icon>,
        route: "/faculty",
        component: <Faculty/>,
        resource:'Faculty',
      },
      {
        type: "collapse",
        name:"Department",
        key: "department",
        icon: <Icon fontSize="small" style={{color: "gray"}}>radio_button_unchecked</Icon>,
        route: "/department",
        component: <Departmentv2/>,
        resource:'Department',
      },
      {
        type: "collapse",
        name:"Programs",
        key: "programs",
        icon: <Icon fontSize="small" style={{color: "gray"}}>radio_button_unchecked</Icon>,
        route: "/programs",
        component: <Program/>,
        resource:'Programs',
      },
    ],
  },
  // {
  //   type: "collapse",
  //   name: "Forms Builder",
  //   key: "forms",
  //   icon: <Icon fontSize="small">reorder</Icon>,
  //   route: "/forms",
  //   component: <Forms />,
  // },
  {
    type: "collapse",
    name:"Quota",
    key: "quota",
    icon: <Icon fontSize="small" style={{color: "gray"}}>pie_chart</Icon>,
    route: "/quota",
    component: <Quota/>,
    resource:'Quota',
  },
  {
    type: "collapse",
    name:"Session",
    key: "batch",
    icon: <Icon fontSize="small" style={{color: "gray"}}>group_work</Icon>,
    route: "/batch",
    component: <Batch/>,
    resource:'Session',
  },
  {
    type: "collapse",
    name: "Campaign",
    key: "campaign",  
    icon: <Icon fontSize="small">campaign</Icon>,
    route: "/campaign",
    component: <Campaign />,
    resource:'Campaign',
  },
  // {
  //   type: "collapse",
  //   name: "POS Vouchers",
  //   key: "pos_vouchers",
  //   icon: <Icon fontSize="small">receipt</Icon>,
  //   route: "/pos_vouchers",
  //   component: <POSVouchers />,
  // },
  {
    type: "collapse",
    name: "Applicant Correction",
    key: "applicant_correction",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/applicant_correction",
    component: <ApplicantCorrection />,
    resource:'Applicant Correction',
  },
  // {
  //   type: "collapse",
  //   name: "Applicants",
  //   key: "applicants",
  //   icon: <Icon fontSize="small">switch_account</Icon>,
  //   route: "/applicants",
  //   component: <Applicants />,
  // },
  // {
  //   type: "collapse",
  //   name: "Users",
  //   key: "admin_users",
  //   icon: <Icon fontSize="small">people_alt</Icon>,
  //   route: "/admin_users",
  //   component: <Users />,
  // },
  {
    type: "nested",
    name: "Draft Management",
    key: "draft_management",
    icon: <Icon fontSize="small">source</Icon>,
    children: [
    {
      type: "collapse",
      name: "Admission Draft Structures",
      key: "admission_draft_structures",
      icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
      route: "/admission_draft_structures",
      component: <AdmissionDraftStructures />,
      resource:'DraftStructure',
    },
    {
      type: "collapse",
      name: "Application Drafts",
      key: "application_drafts",
      icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
      route: "/application_drafts",
      component: <ApplicationDrafts />,
      resource:'ApplicationDrafts',
    },
  ],
  },
  {
    type: "nested",
    name: "Applications Management",
    key: "applications_management",
    icon: <Icon fontSize="small">source</Icon>,
    children: [
      {
        type: "collapse",
        name: "Add Re-Admission Application",
        key: "re_admission_application",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/re_admission_application",
        component: <AffiliateApplication />,
        resource:'AddReAdmissionApplication',
      },
      // {
      //   type: "collapse",
      //   name: "Upload Affiliate Applicant",
      //   key: "upload_affiliate",
      //   icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
      //   route: "/upload_affiliate",
      //   component: <UploadAffiliateCollege />,
      // },
      // {
      //   type: "collapse",
      //   name: "Manage Applications",
      //   key: "manage_applications",
      //   icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
      //   route: "/manage_applications",
      //   component: <ManageApplications />,
      // },
      {
        type: "collapse",
        name: "Search Applications",
        key: "search_applications",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/search_applications",
        component: <SearchApplications />,
        resource:'Search Applications',
      },
      {
        type: "collapse",
        name: "Allow Application",
        key: "allow_application",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/allow_application",
        component: <AllowApplication />,
        resource:'AllowApplication',
      },
      {
        type: "collapse",
        name: "Review Applications",
        key: "review_applications",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/review_applications",
        component: <ReviewApplications />,
        resource:'Review Applications',
      },
      {
        type: "collapse",
        name: "Basic Info Correction",
        key: "basic_info_correction",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/basic_info_correction",
        component: <BasicInfoCorrection />,
        resource:'Basic Info Correction',
      },
      {
        type: "collapse",
        name: "Academics Info Correction",
        key: "academics_info_correction",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/academics_info_correction",
        component: <AcademicsInfoCorrection />,
        resource:'Academics Info Correction',
      },
      {
        type: "collapse",
        name: "Program Correction",
        key: "program_correction",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/program_correction",
        component: <ProgramCorrection />,
        resource:'Program Correction',
      },
      {
        type: "collapse",
        name: "Test Correction",
        key: "test_correction",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/test_correction",
        component: <TestCorrection />,
        resource:'TestCorrection',
      },
      // {
      //   type: "collapse",
      //   name: "Merit Lists",
      //   key: "merit_lists",
      //   icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
      //   route: "/merit_lists",
      //   component: <MeritList />,
      // },
      {
        type: "collapse",
        name: "Merit List Templates",
        key: "merit_lists_templates",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/merit_lists_templates",
        component: <MeritListTemplates />,
        resource:'MeritListTemplate',
      },
      {
        type: "collapse",
        name: "Merit Lists",
        key: "merit_lists",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/merit_lists",
        component: <MeritListV2 />,
        resource:'Merit Lists',
      },
      {
        type:"collapse",
        name: "Bulk Merit List",
        key: "bulk_merit_list",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/bulk_merit_list",
        component: <BulkMeritList />,
        resource:'BulkMeritList',
      },
      {
        type: "collapse",
        name: "Waiting Lists",
        key: "waiting_lists",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/waiting_lists",
        component: <WaitingList />,
      },
      // {
      //   type: "collapse",
      //   name: "Selected Applications",
      //   key: "selected_applications",
      //   icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
      //   route: "/selected_applications",
      //   component: <SelectedApplications />,
      // },
      {
        type: "collapse",
        name: "Selected Applications",
        key: "pre_register_applications",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/pre_register_applications",
        component: <PreRegisterApplications />,
        resource:'Selected Applications',
      },
      {
        type: "collapse",
        name: "Fee Transfer",
        key: "fee_transfer",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/fee_transfer",
        component: <FeeTransfer />,
        resource:'FeeTransfer',
      },
      {
        type: "collapse",
        name: "Shift Program (No Fees)",
        key: "shift_program",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/shift_program",
        component: <ShiftProgram />,
        resource:'ShiftProgram',
      },
      {
        type: "collapse",
        name: "Admission Cancel",
        key: "admission_cancel",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/admission_cancel",
        component: <AdmissionCancel />,
        resource:'AdmissionCancel',
      },
      {
        type: "collapse",
        name: "Sport Trial Applications",
        key: "sport_trial_applications",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/sport_trial_applications",
        component: <SportTrialApplications />,
        resource:'SportTrialApplications',
      },
      // {
      //   type: "collapse",
      //   name: "Export Applications Settings",
      //   key: "export_applications",
      //   icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
      //   route: "/export_applications",
      //   component: <ExportApplication />,
      // },
    ],
  },
  {
    type: "nested",
    name: "Entry Test Management",
    key: "entry_test_management",
    icon: <Icon fontSize="small">quiz_icon</Icon>,
    children: [
      {
        type: "collapse",
        name: "Entry Tests",
        key: "entry_tests",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/entry_tests",
        component: <EntryTests />,
        resource:'Entry Tests',
      },
      // {
      //   type: "collapse",
      //   name: "Test/Interview Scores",
      //   key: "test_interview_scores",
      //   icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
      //   route: "/test_interview_scores",
      //   component: <TestInterviewScores />,
      // },
      {
        type: "collapse",
        name: "Test Results Entry",
        key: "test_results_entry",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/test_results_entry",
        component: <TestResultEntry />,
        resource:'Test Results Entry',
      },
      {
        type: "collapse",
        name: "Test Results Upload",
        key: "test_results_upload",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/test_results_upload",
        component: <TestUpload />,
        resource:'Test Results Upload',
      },
    ],
  },
  {
    type: "nested",
    name: "Financial Assistance",
    key: "financial_assistance",
    icon: <Icon fontSize="small">payment</Icon>,
    children: [
      {
        type: "collapse",
        name: "Fee Structure",
        key: "fee_structure",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/fee_structure",
        component: <FeeStructureV2 />,
        resource:'FeeStructure',
      },
      {
        type: "collapse",
        name: "Processing Vouchers",
        key: "processing_vouchers",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/processing_vouchers",
        component: <Vouchers />,
        resource:'Processing Vouchers',
      },
      {
        type: "collapse",
        name: "Registrar Voucher",
        key: "registrar_vouchers",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/registrar_vouchers",
        component: <RegistrarVouchers />,
        resource:'Registrar Vouchers',
      },
      {
        type: "collapse",
        name: "Semester Vouchers",
        key: "semester_vouchers",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/semester_vouchers",
        component: <SemesterVouchers />,
        resource:'SemesterVouchers',
      },
      {
        type: "collapse",
        name: "Hostel Vouchers",
        key: "hostel_vouchers",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/hostel_vouchers",
        component: <HostelVouchers />,
        resource:'HostelVouchers',
      },
      {
        type: "collapse",
        name: "Consolidated Voucher Report",
        key: "consolidated_voucher_report",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/consolidated_voucher_report",
        component: <ConsolidatedVoucherReport />,
        resource:'ConsolidatedVoucherReport',
      },
    ],
  },
  {
    type: "nested",
    name: "Voucher Reconciliation",
    key: "voucher_reconciliation",
    icon: <Icon fontSize="small">account_balance</Icon>,
    children: [
      {
        type: "collapse",
        name: "Dashboard",
        key: "reconciliation_dashboard",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/reconciliation_dashboard",
        component: <ReconciliationDashboard />,
        resource:'ReconciliationDashboard',
      },
      {
        type: "collapse",
        name: "Upload Bank File",
        key: "upload_bank_file",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/upload_bank_file",
        component: <UploadBankFile />,
        resource:'UploadBankFile',
      },
    ],
  },
  {
    type: "nested",
    name: "Reports",
    key: "reports",
    icon: <Icon fontSize="small">pie_chart</Icon>,
    children: [
      {
        type: "collapse",
        name: "Admission Summary Report",
        key: "admission_summary_report",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/admission_summary_report",
        component: <AdmissionSummaryReport />,
        resource:'AdmissionSummaryReport',
      },
      {
        type: "collapse",
        name: "Transferred Applications",
        key: "transferred_applications",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/transferred_applications",
        component: <TransferredApplications />,
        resource:'TransferredApplications',
      },
      {
        type: "collapse",
        name: "Test Candidate Report",
        key: "test_candidate_report",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/test_candidate_report",
        component: <TestCandidateReport />,
        resource:'TestCandidateReport',
      },
      {
        type: "collapse",
        name: "User Login Report",
        key: "user_login_report",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/user_login_report",
        component: <UserLoginReport />,
        resource:'UserLoginReport',
      },
      {
        type: "collapse",
        name: "Allowed Applicant Report",
        key: "allowed_applicant_report",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/allowed_applicant_report",
        component: <AllowedApplicantReport />,
        resource:'AllowedApplicantReport',
      },
      {
        type: "collapse",
        name: "Fee Collection Report",
        key: "fee_collection_report",
        icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
        route: "/fee_collection_report",
        component: <FeeCollectionReport />,
        resource:'FeeCollectionReport',
      },
    ],
  },
  // {
  //   type: "nested",
  //   name: "Template Management",
  //   key: "template_management",
  //   icon: <Icon fontSize="small">view_agenda</Icon>,
  //   children: [
  //     {
  //       type: "collapse",
  //       name: "Test Slip Template",
  //       key: "test_slip_template",
  //       icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
  //       route: "/test_slip_template",
  //       component: <EntryTestTemplate />,
  //     },
  //     {
  //       type: "collapse",
  //       name: "Voucher Template",
  //       key: "voucher_template",
  //       icon: <Icon fontSize="small">radio_button_unchecked</Icon>,
  //       route: "/voucher_template",
  //       component: <VoucherTemplate />,
  //     },
  //   ]
  // },
  // {
  //   type: "nested",
  //   name: "Bank Management",
  //   key: "bank_management",
  //   icon: <Icon fontSize="small">local_atm</Icon>,
  //   children: [
  //     {},
  //   ]
  // },
  {
    type: "collapse",
    name: "Make Student",
    key: "make_student",
    icon: <Icon fontSize="small">people_alt</Icon>,
    route: "/make_student",
    component: <MakeStudent/>,
    resource: 'MakeStudent'
  },
  {
    type: "collapse",
    name: "Send Request to HMS",
    key: "send_request_to_hms",
    icon: <Icon fontSize="small">send</Icon>,
    route: "/send_request_to_hms",
    component: <SendRequestToHMS/>,
    resource: 'SendRequestToHMS'
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/settings",
    component: <SettingsV2 />,
    resource: 'Admissions Settings'
  },
 
];
function filterRoutes(routes, role = "ADMISSION") {
  return routes.reduce((acc, route) => {
    const { resource, type, children } = route;

    if (type === "nested" && Array.isArray(children)) {
      const filteredChildren = children.filter(child =>
        !child.resource || hasResource(child.resource, role)
      );

      if (filteredChildren.length > 0) {
        acc.push({ ...route, children: filteredChildren });
      }

      return acc;
    }

    if (resource && !hasResource(resource, role)) return acc;

    acc.push(route);
    return acc;
  }, []);
}

const filteredRoutes = filterRoutes(routes)
export default filteredRoutes;
